import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons'

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.jpg'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'desktop';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div ref={nodeRef}>
        <div className="login-desktop-container">
          <Row className="login-desktop-header">
            <img src={logo} alt="logo" className="desktop-logo" />
          </Row>
          <Form onSubmit={(event) => onSubmit(event)}>
            <Row className="login-desktop-body">
              <Col>
                <Container fluid={true} className="email-desktop">
                  <Row className="container-input-desktop">
                    <Col sm="2" xs="2" md="2" className="desktop-icon-lbl my-auto ">
                      <FontAwesomeIcon icon={faUser} color="rgba(0,0,0,0.2)" />
                    </Col>
                    <Col sm="10" xs="10" md="10" className="desktop-input">
                      <Input
                        className="user-input-desktop"
                        disabled={onLogin}
                        placeholder={translate("PlaceholderUserName")}
                        required={true}
                        tabIndex={1}
                        type="text"
                        autoCorrect="off"
                        autoCapitalize="none"
                        id="username"
                        onChange={e => setUsername(e.target.value)}
                      />
                    </Col>
                  </Row>
                </Container>
                <Container fluid={true} className="pass-desktop">
                  <Row className="container-input-desktop">
                    <Col sm="2" xs="2" md="2" className="desktop-icon-lbl my-auto ">
                      <FontAwesomeIcon icon={faLock} color="rgba(0,0,0,0.2)" />
                    </Col>
                    <Col sm="10" xs="10" md="10" className="desktop-input">
                      <Input
                        className="pass-input-desktop"
                        required={true}
                        disabled={onLogin}
                        placeholder={translate("PlaceholderPassword")}
                        tabIndex={1}
                        type="password"
                        autoCorrect="off"
                        autoCapitalize="none"
                        id="password"
                        onChange={e => setPassword(e.target.value)}
                      />
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
            <Row className="login-desktop-footer">
              <Col>
                {!onLogin ? (
                  <div className="container-desktop-button">
                    <button
                      block={!parameters.failureRedirect}
                      tabIndex={1}
                      type="submit"
                      id="submmit"
                      className="enter-desktop"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                  </div>
                ) : (
                  <div className="container-progress-bar" style={{ marginTop: 20 }}>
                    <Progress animated color="danger" value={100} className="desktop-progress-bar" />
                  </div>
                )}
                <div className="messages-container">
                  <Alert
                    color="danger"
                    id="error-message"
                    isOpen={error.open}
                    toggle={() => setError({ open: false })}
                  >
                    {error.message}
                  </Alert>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { style: { marginTop: '2rem' } });
